angular.module('natura').directive('pggEdit', [ function() {
  return {
    restrict : "E",
    templateUrl : "assets/terkep/app/edit/edit.html",
    replace : true,
    scope : {
      map : "="
    },
    controller : "PggEditController",
    controllerAs : "ctrl",
    bindToController : true
  };
} ]);